import { getSegmentAnonymousId } from 'lib/getSegmentAnonymousId/getSegmentAnonymousId'
import { getHistory } from 'lib/history'
import { isShortCode } from 'lib/short-codes'
import { storeShortCodePath, storeSearchResultsPath } from 'lib/urls'
import {
  SEARCH_HISTORY_TYPE_PRODUCTS,
  addToSearchHistory,
} from 'shared/utils/searchHistory/searchHistory'

// hard-coded from Most Popular Adds & Reservations- Department
// https://app.periscopedata.com/app/babylist:snowflake/743078/Categorization-Analysis---Activated-Registries
const POPULAR_SEARCHES = [
  'Feeding',
  'Nursery',
  'Playroom',
  'Clothing',
  'Diapering',
]

export const getPopularSearches = () => POPULAR_SEARCHES

export const getLocation = () => getHistory().getCurrentLocation()

export const searchStore = (searchString, onSearch = () => {}) => {
  if (!searchString) return
  addToSearchHistory(searchString, SEARCH_HISTORY_TYPE_PRODUCTS)

  if (isShortCode(searchString)) {
    window.location.href = storeShortCodePath(searchString)
  } else {
    const history = getHistory({ useRouter: true })
    history.push(storeSearchResultsPath(searchString))
  }

  onSearch(searchString)
}

const reduceSuggestions = (suggestions) =>
  suggestions.map((s) => s.search_term || s.search_terms)

export const getSearchSuggestions = (key, searchString) => {
  const query = encodeURIComponent(searchString)
  const segmentAnonymousId = getSegmentAnonymousId()
  return fetch(
    `/api/v3/catalog/search_suggestions?q=${query}&segment_anonymous_id=${segmentAnonymousId}`,
    {
      method: 'GET',
    }
  )
    .then((response) => response.json())
    .then((data) => reduceSuggestions(data.search_suggestions))
}
